export default {
    dealer_overview_title: 'Dealer',
    dealer_overview_actions: 'Actions',
    dealer_overview_username: 'Username',
    dealer_overview_opened_at: 'Opened at',
    dealer_overview_status: 'Status',
    dealer_overview_package: 'Package',
    dealer_overview_devices: 'Devices',
    dealer_overview_brand: 'Brand',
    dealer_overview_crm: 'Salesforce Id',
    dealer_overview_activities: 'Activities',
    dealer_overview_keysfobs: 'DriverID Tags',
    dealer_overview_user: 'Users',

    dealer_overview_edit_dealer: 'Edit Dealer',
    dealer_overview_reset_legacy_user: 'Reset Dealer Password',
    dealer_overview_change_dealer_status: 'Change Dealer Status',
    dealer_overview_change_dealer_brand: 'Change Dealer Brand',
    dealer_overview_import_and_assign: 'Import and Assign',
    dealer_overview_reset_cognito_user: 'Reset Cognito Authentication',
    dealer_overview_device_models: 'Device Models',
    dealer_overview_part_numbers: 'Part Numbers',
    dealer_overview_unit_types: 'Unit Types',
    dealer_overview_active_devices: 'Active Devices',
    dealer_overview_system_alert_logs: 'System Alert Logs',
    dealer_overview_scheduled_reports: 'Scheduled Reports',
    dealer_overview_email: 'Email',
    dealer_overview_export_logs: 'Export Logs',
    dealer_overview_terms_conditions: 'Verify Terms and Conditions',
    dealer_overview_scheduled_actions: 'Schedule Actions',
    dealer_overview_change_username: 'Change Username',

    dealer_overview_master_company: 'Master Company',
    dealer_overview_tab_accounts: "Accounts",
    dealer_overview_tab_packages: "Packages",
    dealer_overview_tab_billing_accounts: "Billing Accounts",
    dealer_overview_tab_alert_logs: "Alert Logs",
    dealer_overview_tab_webhooks: "WebHooks",
};

